export const asPrice = (value) => value.toLocaleString('en-US');